import React from 'react';
import { useIntl } from 'react-intl';

import MenuEditorSidepanel from 'modules/menu/components/MenuEditorSidepanel';
import { trackSidePanel } from 'modules/shared-menu/telemetry';

import { AddOrCopyOffer } from './AddOrCopyOffer';
import { OfferOverridesProvider } from '../context/OfferOverridesContext';
import { OfferTabProvider } from '../context/OfferTabContext';
import { ProductOverridesProvider } from '../context/ProductOverridesContext';
import { Offer } from '../types';

type Props = {
  itemToCopy?: Offer;
  initialCategoryId: string | null;
  onSuccess: () => void;
  onClose: () => void;
};
export const NewOfferSidePanel = ({ itemToCopy, initialCategoryId, onSuccess, onClose }: Props) => {
  const intl = useIntl();

  trackSidePanel.viewOffer();

  return (
    <MenuEditorSidepanel
      id={itemToCopy?.id || 'new-item'}
      title={intl.formatMessage({ id: 'menu-item.addItemHeader' })}
      onClose={onClose}
    >
      <OfferTabProvider>
        <OfferOverridesProvider>
          <ProductOverridesProvider>
            <AddOrCopyOffer
              itemToCopy={itemToCopy}
              initialCategoryId={initialCategoryId}
              onSuccess={onSuccess}
              onClose={onClose}
            />
          </ProductOverridesProvider>
        </OfferOverridesProvider>
      </OfferTabProvider>
    </MenuEditorSidepanel>
  );
};
